import React, {useEffect} from 'react';
import {PoppaysLoader} from '@lightricks/react-design-system';
import {getEnv} from '@/config/environment';

const LOGIN_CALLBACK_BRANDS_PATH = '/authentication/login_callback/brands';

export default function WebPaymentsLoginRedirect() {
  useEffect(() => {
    const redirectAfterLoginUrl = `${getEnv().VITE_API_HOST}${LOGIN_CALLBACK_BRANDS_PATH}`;
    const loginUrl = `${getEnv().VITE_WEB_PAYMENT_LOGIN_URL}?redirectAfterLogin=${encodeURIComponent(redirectAfterLoginUrl)}`;
    window.location.href = loginUrl;
  }, []);

  return <PoppaysLoader />;
}
